import styled from 'styled-components';
import SEARCH from '../../../assets/imgs/icon/search.svg';
import { IconButton } from '../../../GlobalComponents/IconButton';
import { DisplayValue } from '../../../types';
import { Link } from 'react-router-dom';
export const SearchIcon: React.FC<{
	onClick?: () => void;
	marginRight?: string | number;
	marginLeft?: string | number;
	display?: DisplayValue;
	smdisplay?: DisplayValue;
}> = ({ onClick, display, marginLeft, marginRight, smdisplay }) => {
	return (
		<SearchIconContainer
			$smdisplay={smdisplay}
			$display={display}
			$marginLeft={marginLeft}
			$marginRight={marginRight}
		>
			<IconButton
				url={SEARCH}
				alt={'search'}
				onClick={onClick}
				width={24}
				height={24}
			></IconButton>
		</SearchIconContainer>
	);
};

export interface FormInputProps extends React.CSSProperties {
	hover?: React.CSSProperties;
}

export const FormInput = styled.input<FormInputProps>`
	display: ${props => props.display ?? 'block'};
	width: ${props => props.width ?? '100%'};
	font-size: ${props => props.fontSize ?? '1rem'};
	font-weight: ${props => props.fontWeight ?? '400'};
	line-height: ${props => props.lineHeight ?? '1.5'};
	color: ${props => props.color ?? '#3212529'};
	background-color: ${props => props.backgroundColor ?? '#fff'};
	background-clip: ${props => props.backgroundClip ?? 'padding-box'};
	border: ${props => props.border ?? '1px solid #ced4da'};
	appearance: ${props => props.appearance ?? 'none'};
	border-radius: ${props => props.borderRadius ?? '0'};
	transition: ${props =>
		props.transition ??
		'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out'};
	position: ${props => props.position ?? 'relative'};
	flex: ${props => props.flex ?? '1 1 auto'};
	width: ${props => props.width ?? '1%'};
	height: ${props => props.height ?? '100%'};
	min-width: ${props => props.minWidth ?? '0'};
	max-width: ${props => props.maxWidth ?? '0'};
	&:focus {
		color: ${props => props.hover?.color ?? '#495057'};
		background-color: ${props => props.hover?.backgroundColor ?? '#fff'};
		border-color: ${props => props.hover?.borderColor ?? '#fac29a'};
		outline: ${props => props.hover?.outline ?? '0'};
		box-shadow: ${props =>
			props.hover?.boxShadow ?? '0 0 0 0.2rem rgba(244, 121, 32, 0.25)'};
	}
`;

export const SearchIconContainer = styled.div<{
	$marginRight?: string | number;
	$marginLeft?: string | number;
	$display?: DisplayValue;
	$smdisplay?: DisplayValue;
}>`
	margin-right: ${props => props.$marginRight} !important;
	margin-left: ${props => props.$marginLeft} !important;
	display: ${props => props.$display ?? 'flex'};
	align-items: center;
	justify-content: center;
	@media (min-width: 576px) {
		display: ${props => props.$smdisplay};
	}
`;

export const SearchItemContainer = styled.div<{ $height?: string | number }>`
	height: ${props => props.$height}px;
	width: 100%;
`;

export const SearchLink = styled(Link)`
	transition: all 0.2s ease-in-out;
	padding-left: 0.5rem !important;
	padding-top: 0.25rem !important;
	padding-bottom: 0.25rem !important;
	padding-right: 0.5rem !important;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	display: block !important;
	font-size: 0.875em;
	&:hover {
		background-color: rgba(244, 121, 32, 0.2) !important;
	}
`;

export const SearchResultContainer = styled.div<{
	$height?: string | number;
	$opacity?: string | number;
}>`
	height: ${props => props.$height}px;
	transition:
		height 1s ease,
		opacity 1s ease;
	top: 100%;
	left: 0;
	right: 0;
	overflow: hidden;
	border: 1px solid #f47920;
	position: absolute;
	opacity: ${props => props.$opacity};
	background-color: #fff;
	width: 100%;
`;
